export const TestListActionTypes = {
    GET_TESTS:"GET_TESTS"
}